import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AadeBookInvoiceType, InvoiceRowType } from '../../../interfaces/myData.interface';
import { GsisDocMeta, GsisDocPartyCard, GsisDocPaymentMethods, GsisDocProductsList, GsisDocSummary } from './gsis';

interface Props {
  doc: AadeBookInvoiceType;
}

export const DeliveryStatusGsisDoc = ({ doc }: Props) => {
  const { t } = useTranslation();

  const products = useMemo<InvoiceRowType[]>(() => {
    if (!doc) return [];
    const p = doc.invoiceDetails ?? [];
    return Array.isArray(p) ? p : [p];
  }, [doc]);

  if (!doc) return null;

  return (
    <div className="width-100 max-width-900">
      <div className="boldText5 margin-b-12 text-center">{t('DELIVERY.GSIS_DOC')}</div>

      <div className="width-100">
        <GsisDocMeta doc={doc} />
      </div>

      <div className="width-100 margin-t-12">
        <div className="flex-center-center-row-wrap gap-16 width-100">
          <div style={{ flex: '1 1 320px', maxWidth: 520 }}>
            <GsisDocPartyCard title={t('DELIVERY.ISSUER')} party={doc.issuer} />
          </div>
          <div style={{ flex: '1 1 320px', maxWidth: 520 }}>
            <GsisDocPartyCard title={t('DELIVERY.COUNTERPART')} party={doc.counterpart} />
          </div>
        </div>
      </div>

      <div className="width-100 margin-t-12">
        <GsisDocSummary doc={doc} />
      </div>

      {doc.paymentMethods && (
        <div className="width-100 margin-t-12">
          <GsisDocPaymentMethods doc={doc} />
        </div>
      )}

      <div className="width-100 margin-t-12">
        <GsisDocProductsList products={products} />
      </div>
    </div>
  );
};
